import React from 'react';
import { string, node } from 'prop-types';
import ItemRelatedGroups from '../components/item-related-groups/ItemRelatedGroups';

const ZoneCard = ({ children }) => {
  return (
    <div className="sui-w-full sui-bg-primary sui-rounded-base sui-mb-4 sui-max-w-screen-2xl">
      {children}
    </div>
  );
};

export const pipItemRelatedGroups = (props) => {
  return (
    <ItemRelatedGroups
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      hydrator={{
        className: 'grid',
        tag: ZoneCard,
        id: 'itemRelatedGroups',
        delay: 1500,
        scrollBuffer: 750
      }}
    />
  );
};

ZoneCard.propTypes = {
  children: node.isRequired
};

pipItemRelatedGroups.propTypes = {
  anchorId: string.isRequired
};

pipItemRelatedGroups.displayName = 'pipItemRelatedGroups';